var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"control is-flex is-align-items-center",class:[_vm.notificationClass, _vm.textclass]},[_c('div',{staticClass:"mr-4"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"mdi mdi-36px",class:_vm.icon})])]),_vm._t("text-content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }